import { combineReducers } from '@reduxjs/toolkit';
import bagSaga from '@state/features/bag.saga';
import bagSlice from '@state/features/bag.slice';
import { all, fork } from 'redux-saga/effects';
export const bagRootReducer = combineReducers({
    bag: bagSlice.reducer,
});
export function* bagRootSaga() {
    yield all([fork(bagSaga)]);
}
